import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/hill_dark_logo.png";
import x_logo from "../../fonts/x_logo.svg";
import Projects from "../../api/projects";

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="blog" />
                </div>
                <p>
                  Welcome to Hill Academy, where we empower youth to reach their
                  fullest potential and make a change in the world!
                </p>
                <ul>
                  <li>
                    <Link to="/">
                      <i className="ti-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      {/* <i className="ti-twitter-alt"></i> */}
                      <img
                        src={x_logo}
                        alt="X"
                        style={{
                          width: 17,
                          height: 17,
                          marginLeft: "2px",
                          marginBottom: "9px",
                        }}
                      />
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/hillacademyepa/"
                      target="_blank"
                    >
                      <i className="ti-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <Link to="/">
                      <i className="ti-google"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Services </h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/testimonial">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="#" onClick={(e) => e.preventDefault()}>
                      Causes
                    </Link>
                  </li>
                  <li>
                    <Link to="#" onClick={(e) => e.preventDefault()}>
                      Latest News
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact us
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/event">
                      Events
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contact </h3>
                </div>
                <div className="contact-ft">
                  <p>
                    Please feel free to contact us with any inquiries or
                    suggestions
                  </p>
                  <ul>
                    <li>
                      <i className="fi flaticon-mail"></i>
                      info@hillacademyepa.org
                    </li>
                    <li>
                      <i className="fi flaticon-phone-call"></i>+1 (215)
                      753-5640
                    </li>
                    <li>
                      <i className="fi flaticon-location"></i>Bethlehem – 3833
                      Devonshire Road
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                        <div className="widget instagram">
                            <div className="widget-title">
                                <h3>Projects</h3>
                            </div>
                            <ul className="d-flex">
                                {Projects.slice(0,6).map((project, pitem)=>(
                                    <li className="grid" key={pitem}>
                                        <div className="img-holder">
                                            <Link onClick={ClickHandler} to={`/project-single/${project.id}`}>
                                                <img src={project.projectImg} alt=""/>
                                            </Link>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div> */}
            <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Projects </h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/academic-counseling">
                      Academic Counseling
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/mentorship">
                      Mentorship
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="service-single/2">
                      Education
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              {/* <p className="copyright"> &copy; 2021 charitio Theme. Design By <Link to="/index">wpOcean</Link>. All Rights Reserved.</p> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
